import config from '@/../service/project.config';
import axios from 'axios';
import { CwxBackend } from '@/types/cwxBackend';

export default {
  async getUserTopMenu(): Promise<CwxBackend.IMegaMenuViewModel> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/navigations/getUserTopMenuItem`;

    return axios.get(endpointUrl).then((response) => {
      return response.data;
    });
  },

  async getSpaceNavigationMenu(spaceId: number): Promise<CwxBackend.ISpaceMenuItemDto[]> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/navigations/getSidebarMenuItems?spaceId=${spaceId}`;

    return axios.get(endpointUrl).then((response) => {
      return response.data;
    });
  },
};
